import Observer from '~utilities/observer';

class InAnimation {
    constructor(element) {
        element.classList.add('u-in-animation');
        new Observer(element, this);
    }

    observerTrigger(target) {
        target.classList.add('in-animation--triggered');
    }

}

export default InAnimation;